import { composeRefs } from '@radix-ui/react-compose-refs';
import { forwardRef, isValidElement, cloneElement } from 'react';

const InjectAside = forwardRef((props, ref) => {
  const { children, side, ...injectAsideProps } = props;
  if (isValidElement(children)) {
    return cloneElement(children, {
      ...injectAsideProps,
      ...children.props,
      side,
      ref: composeRefs(ref, children?.ref)
    });
  }
  return children;
});

export { InjectAside as default };
//# sourceMappingURL=InjectAside.mjs.map
